// Settings › Wording: the organisation's own words for platform phrases.
// English only (empty az/ru) while the product is English only.
import type { Phrase } from '../staffText'

export const wording = {
  'wording.section': { en: 'Wording', az: '', ru: '' },
  'wording.also': { en: 'words phrases text translation terms rename', az: '', ru: '' },
  'wording.line': { en: 'Replace any platform word.', az: '', ru: '' },
  'wording.language': { en: 'Language', az: '', ru: '' },
  'wording.list': { en: 'Phrases', az: '', ru: '' },
  'wording.count': { en: '{n, plural, one {# phrase} other {# phrases}}', az: '', ru: '' },
  'wording.find': { en: 'Find a phrase', az: '', ru: '' },
  'wording.filter': { en: 'Show', az: '', ru: '' },
  'wording.all': { en: 'All', az: '', ru: '' },
  'wording.changed': { en: 'Changed', az: '', ru: '' },
  'wording.screens': { en: 'Screens', az: '', ru: '' },
  'wording.col.english': { en: 'English', az: '', ru: '' },
  'wording.col.platform': { en: 'Platform', az: '', ru: '' },
  'wording.col.yours': { en: 'Yours', az: '', ru: '' },
  'wording.reset': { en: 'Reset', az: '', ru: '' },
  'wording.save': { en: 'Save', az: '', ru: '' },
  'wording.saving': { en: 'Saving…', az: '', ru: '' },
  'wording.editLabel': { en: 'Your word', az: '', ru: '' },
  'wording.saved': { en: 'Wording saved', az: '', ru: '' },
  'wording.wasReset': { en: 'Wording reset', az: '', ru: '' },
  'wording.none': { en: 'No phrase matches', az: '', ru: '' },
  'wording.more': { en: '{shown} of {n} shown. Refine search.', az: '', ru: '' },
  'wording.notLoaded': { en: 'Wording not loaded', az: '', ru: '' },
  'wording.problem.empty': { en: 'Enter a word', az: '', ru: '' },
  'wording.problem.long': { en: 'At most {max} characters', az: '', ru: '' },
  'wording.problem.markup': { en: 'No < or >', az: '', ru: '' },
  'wording.problem.placeholders': { en: 'Keep {names}', az: '', ru: '' },
  'wording.problem.noPlaceholders': { en: 'No placeholders here', az: '', ru: '' },
  'wording.problem.onlyPlaceholders': { en: 'Only {names}', az: '', ru: '' },
  'wording.mayUse': { en: 'Can use {names}', az: '', ru: '' },
} satisfies Record<string, Phrase>
